import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcExpandMore32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m24 12c.562 0 1 .406 1 1 0 .25-.094.5-.281.719l-8 8a1.101 1.101 0 0 1 -.719.28c-.25 0-.5-.093-.719-.28l-8-8a1.101 1.101 0 0 1 -.28-.719c0-.25.093-.5.28-.719a1.1 1.1 0 0 1 .72-.28c.25 0 .5.093.718.28l7.281 7.313 7.281-7.313c.219-.187.469-.281.719-.281z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcExpandMore32;
